<template>
    <list-page-shell title="已完成">
        <order-workbench
            :extra-query-params="{ is_archived: 1 }"
            :show-create-button="false"
            :show-title="false"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'ArchivedOrderList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/ArchivedOrderList.vue